<template lang="html">
  <v-flex pa-3>
    <div class="no-print">
      <v-row class="">
        <v-col>
          <SiInputNumber
            :value="splitPercent"
            label="Split percentage"
            decimals="5"
            incriment="1"
            prefix="%"
            :max="100"
            :min="0"
            shaped
            outlined
            @input="handlePercentChange"
          />
        </v-col>
        <v-col>
          <SiInputCurrency
            :value="splitBaseAmount"
            label="Split base amount"
            shaped
            outlined
            @input="handleBaseChange"
          />
        </v-col>
      </v-row>
      <v-col class="pa-0 ">
        <v-slider
          ref="slider"
          v-model="splitSlider"
          label="Split"
          class="si-split-percentage-slider"
          thumb-label
          :min="0"
          :max="100"
        >
          <template #thumb-label="{ value }">
            {{ value }}%
          </template>
        </v-slider>
      </v-col>
    </div>

    <div class="only-print">
      <v-row class="">
        <v-col cols="6">
          Split percentage
          <div class="text-h5">
            {{ splitPercent }}%
          </div>
        </v-col>
        <v-col cols="6">
          Split base amount
          <div class="text-h5">
            {{ _$(splitBaseAmount, 0) }}
          </div>
        </v-col>
      </v-row>
    </div>
  </v-flex>
</template>

<script>
import helpers from '@/mixins/helpers'
export default {
  mixins: [ helpers ],
  props: {
    value:{
      type: Number,
      default: 0
    },
    totalValue: Number,
    secondary: Boolean
  },
  data () {
    return {
      splitSlider: 0,
      updateTimeout: null,
      internalChange: false,
      splitPercent: 0,
      splitBaseAmount: 0,
    }
  },
  watch: {
    splitSlider (percent) {
      if (this.splitPercent !== percent && !this.internalChange) {
        if (this.updateTimeout) clearTimeout(this.updateTimeout)
        this.updateTimeout = setTimeout(() => {
          this.setValues({ percent })
        }, 5)
      }
    },
    value: {
      handler (v) {
        this.setValues({percent: v}) 
      },
      immediate: true
    },
    splitPercent (v) {
      this.$emit('input', Number(v))
    },
    totalValue () {
      let amount = this.splitBaseAmount
      this.setValues({ amount })
    }
  },
  mounted () {
    setTimeout(() => {
      if (!this.$refs.slider || this.secondary) return 
      let thumb = this.$refs.slider.$el.getElementsByClassName('v-slider__thumb-container')[0]
      if (thumb) {
        thumb.focus()
        setTimeout(() => thumb.blur(), 800)
      }
    }, 1500)
    setTimeout(() => this.show = true, 100) // do this to delay load. Makes rendering report smoother as this contains so many graphs
  },
  methods: {
    handlePercentChange (percent) {
      this.setValues({ percent })
    },
    handleBaseChange (amount) {
      this.setValues({ amount })
    },
    setValues ({percent, amount}) {
      this.internalChange = true
      if (percent !== undefined) {
        amount = Number(((Math.floor(this.totalValue / 100) * (percent / 100)) * 100).toFixed(0))
      } else if (amount !== undefined) {
        percent = Math.floor(amount / 100) / Math.floor(this.totalValue / 100) * 100
      } else {
        return 
      }

      if (isNaN(amount)) amount = 0

      this.splitSlider = percent
      this.splitPercent = percent
      this.splitBaseAmount = amount

      this.$nextTick(() => {this.internalChange = false})
    }
  }
}
</script>

<style lang="css">
  .v-slider__thumb-container:focus .v-slider__thumb:before {
    transform: scale(1);
  }
  .si-split-percentage-slider label{
    width: 70px;
  }
</style>
